import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { UserProfile } from "../../../../../setup/api/services/contract/models";
import { GET_PARTY_STATUSES } from "../../../../../components/contract/payeeTable/constants";

interface IPartyCard {
  isPayee?: boolean;
  isLoggedInUser?: boolean;
  name?: string;
  phone: string;
  image?: string;
  amount: string;
  receive?: string;
  fees?: string;
  hasStatus?: boolean;
  row: Partial<UserProfile>;
  isPayeeNoStatus?: boolean;
}

const PartyCard = ({
  isPayee,
  isLoggedInUser,
  name,
  phone,
  image,
  amount,
  receive,
  fees,
  hasStatus,
  row,
  isPayeeNoStatus,
}: IPartyCard) => {
  const { t } = useTranslation();
  const partiesStatuses = GET_PARTY_STATUSES(t);

  return (
    <div
      className={classNames(
        styles.container,
        isLoggedInUser ? styles.logged_in_container : ""
      )}>
      <div className={styles.header}>
        <div className={styles.image_container}>
          <img src={image || "/assets/images/svg/user.svg"} alt="" />
        </div>
        <div className={styles.header_content}>
          <p
            className={classNames(
              !name ? styles["g400"] : "",
              styles["description"],
              styles.name
            )}>
            {`${name || t("lbl_not_registered_yet")}${
              isLoggedInUser ? ` (${t("YOU")})` : ""
            }`}
          </p>
          <p className={classNames(styles.description, styles.phone)}>
            {phone.slice(0, 4) + " " + phone.slice(4)}
          </p>
        </div>
      </div>

      <div className={styles.content_container}>
        <div className={styles.content}>
          <div className={styles.data_container}>
            <p className={styles.title}>{t("lbl_bank_amount")}</p>
            <p className={styles.description}>
              {amount + " " + t("lbl_saudi_currency")}
            </p>
          </div>

          {fees !== undefined && (
            <div className={styles.data_container}>
              <p className={styles.title}>{t("lbl_loyal_fee")}</p>
              <p className={styles.description}>
                {fees + " " + t("lbl_saudi_currency")}
              </p>
            </div>
          )}
        </div>

        <div className={styles.content}>
          {!isPayeeNoStatus && (
            <div className={styles.data_container}>
              <p className={styles.title}>
                {isPayee ? t("lbl_condition") : t("lbl_loyal_receive")}
              </p>

              <p className={classNames(styles.description, styles["doneText"])}>
                {receive + " " + t("lbl_saudi_currency")}
              </p>
            </div>
          )}

          {hasStatus && (
            <div className={styles.data_container}>
              <p className={styles.title}>{t("lbl_condition")}</p>
              <span
                className={styles.statusPill}
                style={{
                  background: partiesStatuses?.[String(row?.status)]?.color,
                }}>
                <p
                  style={{
                    color: partiesStatuses?.[String(row?.status)]?.textColor,
                  }}>
                  {partiesStatuses?.[String(row?.status)]?.title}
                </p>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PartyCard;
